import type { ConnectionMap } from './connection';
import type { Relation, RelationMap } from './relation';
import type { ScopeVarsMap } from './scope';
import type { NodeTreeList } from './tree';

export enum NodeStateUpdateType {
  NodeMove = 'node-move',
  NodeArrange = 'node-arrange',
  NodeHeightChange = 'node-height-change',
  NodeDelete = 'node-delete',
  NodeUpdate = 'node-update',
  NodeConnect = 'node-connect',
  NodeDisconnect = 'node-disconnect',
}

export type NodeState = {
  changes: NodeStateUpdateType[];
  relations: RelationMap;
  connections: ConnectionMap;
  scopeVars: ScopeVarsMap;
  rootTree: NodeTreeList;
};

export type AttachState =
  | {
      actionNodeId: Relation['id'];
      hoveredNodeId: Relation['id'] | null;
      isDragging: true;
    }
  | {
      actionNodeId: null;
      hoveredNodeId: null;
      isDragging: false;
    };

export type ChangeCallback = (relations: RelationMap) => void;
